import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CreateOverviewEffects } from "./create-overview.effects";
import { CreateOverviewReducer } from "./create-overview.reducer";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('createOverview', CreateOverviewReducer),
    EffectsModule.forFeature([CreateOverviewEffects])
  ],
  providers: [CreateOverviewEffects]
})
export class CreateOverviewStoreModule {
}
